module.exports = __webpack_public_path__ + "assets/img/11_672.a7dc9564.jpg";